import { render, staticRenderFns } from "./PosterModal.vue?vue&type=template&id=23dc3dd4&scoped=true"
import script from "./PosterModal.vue?vue&type=script&lang=js"
export * from "./PosterModal.vue?vue&type=script&lang=js"
import style0 from "./PosterModal.vue?vue&type=style&index=0&id=23dc3dd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc3dd4",
  null
  
)

export default component.exports